interface UrlPreviewProps {
  url: string;
}

export function UrlPreview({ url }: UrlPreviewProps) {
  if (!url) return null;

  return (
    <div className="card-link">
      <span className="url-label">Your Cronyl Card URL</span>
      <code className="url-value">{url}</code>
    </div>
  );
}
